const UPDATE_COUNT_PLAYER = (state, data) => {
	state.countPlayer = data;
};
const UPDATE_REPORT_AFF = (state, data) => {
	state.affReport = data;
};
const UPDATE_SELECT_MONTH = (state, data) => {
	state.selectedMonth = data;
};
const UPDATE_LOADING = (state, data) => {
	state.loading = data;
};
const UPDATE_LOADING_BAR = (state, data) => {
	state.loadingBar = data;
};
const UPDATE_BAR_CHART = (state, data) => {
	state.barChartData.push(data);
};
const UPDATE_BAR_CHART_PROGRESS = (state, data) => {
	state.barValue = state.barValue + data;
};

const CLEAR_BAR_CHART_PROGRESS = (state) => {
	state.barValue = 0;
	state.barChartData = []
};
export default {
	CLEAR_BAR_CHART_PROGRESS,
	UPDATE_BAR_CHART_PROGRESS,
	UPDATE_BAR_CHART,
	UPDATE_REPORT_AFF,
	UPDATE_COUNT_PLAYER,
	UPDATE_SELECT_MONTH,
	UPDATE_LOADING,
	UPDATE_LOADING_BAR
};

